import React from 'react'

function Iphone() {
  return (
    <div>
    <br/> <br/>
    <h1>thes is Iphone page</h1>
    </div>
  )
}

export default Iphone